import type { Cents } from "./types";

// Display-side helpers for catalog pricing. Money formatting matches
// the brand microcopy bank: "$1,120 / week", "$3,200 / month",
// "$40,000 / year". US English locale with thousands separator and no
// cents (catalog prices are always whole dollars in the seed data;
// fractional cents are unrealistic for equipment rental rates).
//
// Phase 4c rate-card overhaul: daily tier was removed; pricing is now
// weekly / monthly / yearly only. Weekly is the required floor.

export type Tier = "weekly" | "monthly" | "yearly";

export function formatDollarsRound(cents: Cents | null): string {
  if (cents == null) return "—";
  const dollars = Math.round(cents / 100);
  return `$${dollars.toLocaleString("en-US")}`;
}

export function tierUnit(tier: Tier): string {
  if (tier === "weekly") return "week";
  if (tier === "monthly") return "month";
  return "year";
}

// Phase 4c — "month" is a 4-week period, "year" is 52 weeks. The
// detail tooltip surfaces this to the customer so the math is never a
// surprise.
export function tierDetail(tier: Tier): string {
  if (tier === "weekly") return "1-week minimum";
  if (tier === "monthly") return "4-week period";
  return "52 weeks";
}

export function offeredTiers(type: {
  weekly_rate_cents: Cents | null;
  monthly_rate_cents: Cents | null;
  yearly_rate_cents: Cents | null;
}): Array<{ tier: Tier; cents: Cents }> {
  const tiers: Array<{ tier: Tier; cents: Cents }> = [];
  if (type.weekly_rate_cents && type.weekly_rate_cents > 0) {
    tiers.push({ tier: "weekly", cents: type.weekly_rate_cents });
  }
  if (type.monthly_rate_cents && type.monthly_rate_cents > 0) {
    tiers.push({ tier: "monthly", cents: type.monthly_rate_cents });
  }
  if (type.yearly_rate_cents && type.yearly_rate_cents > 0) {
    tiers.push({ tier: "yearly", cents: type.yearly_rate_cents });
  }
  return tiers;
}
